import defaultIcon from "./assets/default.png";
import iconShanghai from "./assets/icon_shanghai.png";
import iconGongshang from "./assets/icon_gongshang.png"; // 工商银行
import iconNongye from "./assets/icon_nongye.png"; // 农业银行
import iconJianshe from "./assets/icon_jianshe.png"; // 建设银行
import iconJiaotong from "./assets/icon_jiaotong.png"; // 交通银行
import iconZhongguo from "./assets/icon_zhongguo.png"; // 中国银行
import iconZhaoshang from "./assets/icon_zhaoshang.png"; // 招商银行
import iconYouzheng from "./assets/icon_youzheng.png"; // 邮政储蓄银行
import iconXinyongshe from "./assets/icon_xinyongshe.png"; // 农村信用社
import iconNingbo from "./assets/icon_ningbo.png"; // 宁波银行
import iconPufa from "./assets/icon_pufa.png"; // 浦发银行
import iconNanjing from "./assets/icon_nanjing.png"; // 南京银行
import iconSuzhou from "./assets/icon_suzhou.png"; // 苏州银行
import iconJiangsu from "./assets/icon_jiangsu.png"; // 江苏银行
import iconZhongxin from "./assets/icon_zhongxin.png"; // 中信银行
import iconHuifeng from "./assets/icon_huifeng.png"; // 汇丰银行
import iconHuaxia from "./assets/icon_huaxia.png"; // 华夏银行
import iconZheshang from "./assets/icon_zheshang.png"; // 浙商银行
import iconMinsheng from "./assets/icon_minsheng.png"; // 民生银行
import iconGuangda from "./assets/icon_guangda.png"; // 光大银行
import iconZhada from "./assets/icon_zhada.png"; // 渣打银行
import iconPingan from "./assets/icon_pingan.png"; // 平安银行
import iconXingye from "./assets/icon_xingye.png"; // 兴业银行

export const getBankIcon = (bankAccountValue: string): string => {
  const banks = {
    工商银行: iconGongshang,
    农业银行: iconNongye,
    招商银行: iconZhaoshang,
    建设银行: iconJianshe,
    邮政银行: iconYouzheng,
    农村银行: iconXinyongshe,
    宁波银行: iconNingbo,
    交通银行: iconJiaotong,
    浦发银行: iconPufa,
    南京银行: iconNanjing,
    上海银行: iconShanghai,
    苏州银行: iconSuzhou,
    江苏银行: iconJiangsu,
    中信银行: iconZhongxin,
    汇丰银行: iconHuifeng,
    华夏银行: iconHuaxia,
    浙商银行: iconZheshang,
    民生银行: iconMinsheng,
    光大银行: iconGuangda,
    渣打银行: iconZhada,
    平安银行: iconPingan,
    兴业银行: iconXingye,
    中国银行: iconZhongguo,
  };
  let bankText;
  if (bankAccountValue) {
    for (const bank in banks) {
      if (bankAccountValue.includes(bank)) {
        bankText = banks[bank];
        break;
      }
    }
  }
  return bankText || defaultIcon;
};
